import { useUserBankAccountOnboarding } from '~/hooks/useUserBankAccountOnboarding';
import { UserBankAccountBindingError } from '~/types/user-bank-account';
import { UserBankAccountBindingErrorsAlert } from '~/views/accounts/userBankAccounts/UserBankAccountBindingErrorsAlert';
import { UserBankAccountOnboardingAlert } from '~/views/accounts/userBankAccounts/UserBankAccountOnboardingAlert';
import PastDueAlert from '~/views/subscriptions/PastDueAlert';

export const DashboardAlerts = () => {
  const { canStartOnboarding, userBankAccount, isLoading: isLoadingUserBankAccount } = useUserBankAccountOnboarding();

  const shouldContactAdmin =
    userBankAccount?.bindingErrors?.some((error) =>
      [
        UserBankAccountBindingError.BIRTH_DATE_MATCH_ERROR,
        UserBankAccountBindingError.FIRST_NAME_MATCH_ERROR,
        UserBankAccountBindingError.LAST_NAME_MATCH_ERROR,
        UserBankAccountBindingError.FIRST_NAME_MATCH_ERROR,
      ].includes(error),
    ) ?? false;

  if (isLoadingUserBankAccount) {
    return null;
  }

  if (canStartOnboarding && !!userBankAccount)
    return <UserBankAccountOnboardingAlert userBankAccount={userBankAccount} />;

  if (userBankAccount && shouldContactAdmin) return <UserBankAccountBindingErrorsAlert />;

  return <PastDueAlert />;
};
